import React, { useState } from 'react';
import { LuCirclePlay } from "react-icons/lu";
import { IoClose } from "react-icons/io5";
import VideoPlay from '../../assest/video2.mp4'; // Assuming this path is correct
import VideoPlay2 from '../../assest/farmstay/v1.mp4'
import Thumbnail from '../../assest/homestay/8.jpeg'; // Assuming this path is correct
import Thumbnail2 from '../../assest/farmstay/76.jpg';
import bgImage from '../../assest/homestay/25.jpeg'
import './cinematictour.scss'

const Cinematictour = () => {
	const [playVideo, setPlayVideo] = useState(false);
	const [playVideoTwo, setPlayVideoTwo] = useState(false);

	const handleVideoPlay = () => {
		setPlayVideo(true);
		console.log("Attempting to play video. New state for playVideo will be true.");
	}

	const handleVideoPlayTwo = () => {
		setPlayVideoTwo(true);
		console.log("Attempting to play video. New state for playVideo will be true.");
	}

	console.log("Video source imported (VideoPlay variable):", VideoPlay);

	return (
		<section className="cinematic-tour-section">
			<div className="background-overlay">
				<img className="background-image" src={bgImage} alt="Image" />
			</div>
			<div className="content-wrapper">
				<h2 className="Cinematictour-subtitle">Take a Virtual Tour
				</h2>
				<span className="Cinematictour-main-title">Explore Your Stay Before You Book</span>
				<div className="main-Cinematictour-video-placeholder">
					<div className="Cinematictour-video-placeholder">

						{playVideo ? (
							<div className="Cinematictour-video-container">
								<button
									className="close-btn"
									onClick={() => setPlayVideo(false)}
								>
									<IoClose />
								</button>

								<div className="video-wrapper">
									<video
										className="video-frame"
										src={VideoPlay}
										controls
										autoPlay
										playsInline
									/>
								</div>

							</div>
						) : (
							<>
								<img
									src={Thumbnail}
									alt="Video Thumbnail"
									className="video-thumbnail"
								/>


								<div className="Cinematictour-video-overlay"></div>
								<div className="play-button" onClick={handleVideoPlay}>
									<LuCirclePlay className="play-icon" />
								</div>
							</>
						)}
					</div>

					<div className="Cinematictour-video-placeholder">

						{playVideoTwo ? (
							<div className="Cinematictour-video-container">
								<button
									className="close-btn"
									onClick={() => setPlayVideoTwo(false)}
								>
									<IoClose />
								</button>

								<div className="video-wrapper">
								<video
										className="video-frame"
										src={VideoPlay2}
										controls
										autoPlay
										playsInline
									/>
								</div>

							</div>
						) : (
							<>
								<img
									src={Thumbnail2}
									alt="Video Thumbnail"
									className="video-thumbnail"
								/>


								<div className="Cinematictour-video-overlay"></div>
								<div className="play-button" onClick={handleVideoPlayTwo}>
									<LuCirclePlay className="play-icon" />
								</div>
							</>
						)}
					</div>
				</div>
			</div>
		</section>
	);
};

export default Cinematictour;